const bom = {
  bomType: "Loại bom",
  bomCode: "Mã chủ",
  bomName: "Tên bộ phận chính",
  bomModal: "Đặc tính vật liệu",
  bomUnit: "đơn vị đo lường",
  bomVersion: "số phiên bản",
  bomVersionDesc: "Mô tả phiên bản",
  bomVersionDate: "ngày phiên bản",
  bomStatus: "Trạng thái bom",
  approvaler: "Người phê duyệt",
  createDate: "Ngày tạo tập tin",
  creator: "người sáng tạo",
  updateDate: "ngày sửa đổi",
  updater: "công cụ sửa đổi",

  itemLevel: "Cấp độ",
  itemCode: "Mã thành phần",
  itemName: "Tên thành phần",
  itemModal: "đặc tả thành phần",
  itemUnit: "đơn vị đo lường",
  itemBase: "Số lượng cơ bản",
  itemBaseQuantity: "Số lượng cơ bản",
  itemAttritionRate: "Tỷ lệ mất thành phần",
  itemUseQuantity: "Sử dụng số lượng",
  itemEffectiveDate: "Ngày có hiệu lực",
  itemExpiringDate: "Ngày hết hạn",
  itemReMark: "Nhận xét",
  itemLocators: "Bộ định vị 1",
  itemExtraRate: 'Tỷ lệ mất mát',

  itemLevelInfo: "Cấp độ {{ cấp độ }}",
  itemReq: "vật liệu thay thế",

  plBaseUnit: "Xin vui lòng nhập số lượng cơ bản",
  plBaseQuantity: "Vui lòng nhập số lượng cơ bản",
  plAttritionRate: "Vui lòng nhập tỷ lệ thất thoát thành phần",
  plUseQuantity: "Vui lòng nhập số lượng sử dụng",
  plRemark: "Xin vui lòng nhập nhận xét",
  plLocators: "Xin vui lòng nhập định vị 1",

  importError: 'Nhập không thành công',
  bomUpload: 'Tải lên bảng BOM',
  bomDetail: 'Chi tiết BOM',
  closeTip: "Danh sách yêu cầu chưa được tạo, bạn có chắc muốn đóng không?",
  errTip: "Vui lòng kiểm tra dữ liệu",
  errTipdesc: "Ít nhất một vật liệu phải có số lượng yêu cầu lớn hơn 0 mới có thể tiếp tục",
  stockNum: "Số lượng cổ phiếu",
  reqManage: "Quản lý danh sách nhu cầu",
  preStock: "Số lượng dự kiến xuất kho",
  preInStock: "Số lượng dự kiến nhập kho",
  useStock: "Số lượng tồn kho khả dụng",
  prePurNum: "Số lượng cần mua (hàng thường trữ là 0)",
  prePurNum_1: "Số lượng cần mua",
  preOutNum: "Số lượng dự kiến xuất kho (không áp dụng cho hàng thường trữ)",
  preOutNum_1: "Số lượng dự kiến xuất kho",
  matchErr: "Khớp kho thất bại",
  noSaleOrderOrProduct: "Danh sách nhu cầu không có mã hàng cha, không thể xuất kho theo số lượng sản xuất",
  bomUsageMatchErr: "Khớp BOM thất bại, không thể xuất kho theo số lượng sản xuất",
  confirmAdd: "Thêm danh sách nhu cầu (đơn dự kiến xuất kho)",
  inventorySucc: "Đơn dự kiến xuất kho: {{number}} đã được tạo, vị trí xuất kho đã được phân bổ",
  saveTemp: "Lưu mẫu không?",
  merge: "Vật liệu: {{codes}} bị trùng lặp, số lượng yêu cầu đã được cộng dồn",
  editBom: "Chỉnh sửa bảng BOM",
  addBom: "Thêm bảng BOM",
  materialControlTemplate: "Mẫu yêu cầu kiểm soát vật tư",
  originBom: "Vật liệu chính",
  calcErr: "Lỗi phân bổ số lượng vật liệu kết hợp!",
  calcData: "Yêu cầu: Số lượng yêu cầu của vật liệu chính + Tổng số lượng yêu cầu của tất cả vật liệu thay thế = Tổng số lượng tiêu chuẩn của vật liệu chính",
  allocated: "Số lượng tồn kho đã sử dụng",
  expandAll: "Mở rộng tất cả",
  collapseAll: "Thu gọn tất cả",
  parseBonErr: "Phân tích BOM thất bại",
  addTip: "Các vật liệu sau không tồn tại trong hệ thống. Bạn có cần thêm chúng không?",
  notItem: "Các vật liệu sau không tồn tại trong hệ thống, sẽ không tạo dữ liệu đơn nhu cầu",
  fileErr: "Lấy thông tin tệp đính kèm BOM thất bại",
  facStock: "Tồn kho dây chuyền sản xuất",
  facStockAlloc: "Tồn kho dây chuyền đã sử dụng",
  useFactoryCount: "Lượng tồn kho dây chuyền sử dụng",
  realStockNum: "Số lượng tồn kho hiện có",
  realPreStock: "Số lượng xuất kho dự kiến của tồn kho hiện có",
  realUseStock: "Số lượng tồn kho hiện có khả dụng",
  realAllocated: "Số lượng tồn kho hiện có đã sử dụng",
  bomNull: "Không có nguồn dữ liệu BOM khả dụng",
  bomNullTip: "Phải có ít nhất một trong ba: tệp BOM đơn bán hàng, mẫu, hoặc dữ liệu BOM hệ thống",
};

export default bom;
